// extracted by mini-css-extract-plugin
export default {"background":"BotList_background__e7F1V","botListBox":"BotList_botListBox__KaRN+","topBox":"BotList_topBox__S9hKw"};